import React from 'react';
import ListEditor from './ListEditor';
import './ObjectEditor.css';

// object 타입 필드 에디터 (재귀 지원)
// fields: TemplateField[]
// value: Record<string, unknown>
const ObjectEditor = ({ fields = [], value = {}, onChange, disabled = false }) => {
  const handleFieldChange = (key, newValue) => {
    onChange({ ...value, [key]: newValue });
  };

  return (
    <div className="object-editor">
      {fields.map((field) => (
        <div key={field.key} className="object-editor-field">
          <label className="object-editor-label">
            {field.label}
            {field.required && <span className="required-mark"> *</span>}
          </label>
          {renderFieldInput(field, value[field.key], (v) => handleFieldChange(field.key, v), disabled)}
        </div>
      ))}
    </div>
  );
};

const renderFieldInput = (field, value, onChange, disabled) => {
  switch (field.type) {
    case 'string':
      return (
        <textarea
          className="object-editor-textarea"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          rows={3}
          disabled={disabled}
        />
      );

    case 'number':
      return (
        <input
          type="number"
          className="object-editor-input"
          value={value ?? ''}
          min={field.min !== undefined ? field.min : undefined}
          max={field.max !== undefined ? field.max : undefined}
          onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
          disabled={disabled}
        />
      );

    case 'boolean':
      return (
        <label className="object-editor-checkbox-label">
          <input
            type="checkbox"
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
          />
          <span>{field.label}</span>
        </label>
      );

    case 'date':
      return (
        <input
          type="date"
          className="object-editor-input"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
      );

    case 'list':
      return (
        <ListEditor
          value={Array.isArray(value) ? value : []}
          onChange={onChange}
          itemType={field.item_type || 'string'}
          disabled={disabled}
        />
      );

    case 'object':
      return (
        <ObjectEditor
          fields={field.fields || []}
          value={typeof value === 'object' && value !== null ? value : {}}
          onChange={onChange}
          disabled={disabled}
        />
      );

    default:
      return (
        <input
          type="text"
          className="object-editor-input"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
      );
  }
};

export default ObjectEditor;
